var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"md8":"","lg6":""}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$lang("DOUBTS")))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }